import { render, staticRenderFns } from "./AddOfflineSanction.vue?vue&type=template&id=10a5eaac"
import script from "./AddOfflineSanction.vue?vue&type=script&lang=js"
export * from "./AddOfflineSanction.vue?vue&type=script&lang=js"
import style0 from "./AddOfflineSanction.vue?vue&type=style&index=0&id=10a5eaac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports